module.exports = __webpack_public_path__ + "sunsemweb/img/lsfz.984598fa.png";